// extracted by mini-css-extract-plugin
module.exports = {"verticalCenter":"CtaBlockWithButton_verticalCenter__1D_Xz"};